import React from 'react';
import SkeletonWrapper from '@shared/components/skeleton/SkeletonWrapper';

/**
 * @typedef {object} DataCorrelationSkeletonContentProps
 * @property {number} count
 */

/**
 * @param {DataCorrelationSkeletonContentProps} props
 */
const DataCorrelationSkeletonContent = props => {
  const { count } = props;

  return (
    <div className='data-correlation-graph-container'>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonWrapper
          key={index}
          show={true}
          skeletonClassName='data-correlation-skeleton'
          inheritParentSize
        />
      ))}
    </div>
  );
};

export default DataCorrelationSkeletonContent;
